import './Loader.scss'
function Loader(){
    return(
        <div className="background">
      <h1 className="loader">
        <span>L</span>
        <span>O</span>
        <span>A</span>
        <span>D</span>
        <span>I</span>
        <span>N</span>
        <span>G</span>
      </h1>
      </div>
    )
}
export default Loader;